module.exports = __webpack_public_path__ + "static/media/detail-4.4cfc29f7.jpg";